var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inputs-container select-container"},[_c('Select',{staticClass:"select-size select-style",attrs:{"disabled":_vm.disabled},model:{value:(_vm.chosenValue),callback:function ($$v) {_vm.chosenValue=$$v},expression:"chosenValue"}},_vm._l((_vm.transactionTypeList),function(ref){
var key = ref[0];
var value = ref[1];
return _c('Option',{key:key,attrs:{"value":value}},[_vm._v(" "+_vm._s(_vm.$t(("transaction_descriptor_" + value)))+" ")])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }